import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { skillById } from '../../../actions/employer'
import { updateSkills } from '../../../actions/utilitiesAction'
import Add from '../Skills/AddSkills'
import constant from '../../../constant'
import { ForumCategoryById, updateDiscussionForum } from '../../../actions/AddForumAction'
import AddDiscussion from './AddDiscussion'

const ForumList = (props) => {

    const [response, setResponse] = useState({})
    const [showMsg, setShowMsg] = useState(false)
    const navigate = useNavigate()
    const params = useParams()
    const [data, setData] = useState(null)


    useEffect(() => {
        
        console.log(params.id, "params")
        ForumCategoryById(params.id).then((res) => {
            if (res.status) {
                setData(res.result)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch(err => {
            alert(err)
        })
    }, [])

    const onSubmit = (model) => {
        updateDiscussionForum(model).then((res) => {
            if (res.status) {
                navigate(constant.component.DiscussionforumList.url)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            {data && <AddDiscussion
                onSubmit={onSubmit}
                detail={data}
                response={response}
                showMsg={showMsg}
                title="Update forum" />}
        </React.Fragment>
    )
}

export default ForumList